export const BMC_BLOCK_CODES = {
  CS: 'CS', // Customer Segments
  VP: 'VP', // Value Proposition
  CH: 'CH', // Channels
  CR: 'CR', // Customer Relationships (Get Keep Grow)
  KA: 'KA', // Key Activities
  KR: 'KR', // Key Resources
  KP: 'KP', // Key Partners
  CO: 'CO', // Costs
  RE: 'RE', // Revenue
  SU: 'SU', // Sustainability
};

/* eslint-disable import/no-mutable-exports */
let bmcBlocksObject = {};
let bmcBlockTestedOptions = [];
let bmcBlockShortNames = {};
let testStatusBlocks = [];

export function loadBmcBlocks(locales) {
  bmcBlocksObject = {
    [BMC_BLOCK_CODES.CS]: locales.canvas.customerSegment,
    [BMC_BLOCK_CODES.VP]: locales.canvas.valueProposition,
    [BMC_BLOCK_CODES.CH]: locales.canvas.channel,
    [BMC_BLOCK_CODES.CR]: locales.canvas.getKeepGrow,
    [BMC_BLOCK_CODES.KA]: locales.canvas.keyActivity,
    [BMC_BLOCK_CODES.KR]: locales.canvas.keyResources,
    [BMC_BLOCK_CODES.KP]: locales.canvas.keyPartners,
    [BMC_BLOCK_CODES.CO]: locales.canvas.cost,
    [BMC_BLOCK_CODES.RE]: locales.canvas.revenue,
    [BMC_BLOCK_CODES.SU]: locales.canvas.sustainability,
  };

  bmcBlockShortNames = {
    [BMC_BLOCK_CODES.CS]: locales.canvas.csShort,
    [BMC_BLOCK_CODES.VP]: locales.canvas.vpShort,
    [BMC_BLOCK_CODES.CH]: locales.canvas.chShort,
    [BMC_BLOCK_CODES.CR]: locales.canvas.crShort,
    [BMC_BLOCK_CODES.KA]: locales.canvas.kaShort,
    [BMC_BLOCK_CODES.KR]: locales.canvas.krShort,
    [BMC_BLOCK_CODES.KP]: locales.canvas.kpShort,
    [BMC_BLOCK_CODES.CO]: locales.canvas.coShort,
    [BMC_BLOCK_CODES.RE]: locales.canvas.reShort,
    [BMC_BLOCK_CODES.SU]: locales.canvas.suShort,
  };

  testStatusBlocks = [
    BMC_BLOCK_CODES.CS,
    BMC_BLOCK_CODES.VP,
    BMC_BLOCK_CODES.CR,
    BMC_BLOCK_CODES.CH,
    BMC_BLOCK_CODES.KA,
    BMC_BLOCK_CODES.KP,
    BMC_BLOCK_CODES.RE,
    BMC_BLOCK_CODES.SU,
    BMC_BLOCK_CODES.CO,
    BMC_BLOCK_CODES.KR,
  ];

  bmcBlockTestedOptions = [
    { label: bmcBlocksObject[BMC_BLOCK_CODES.CS], value: BMC_BLOCK_CODES.CS },
    { label: bmcBlocksObject[BMC_BLOCK_CODES.VP], value: BMC_BLOCK_CODES.VP },
    { label: bmcBlocksObject[BMC_BLOCK_CODES.CR], value: BMC_BLOCK_CODES.CR },
    { label: bmcBlocksObject[BMC_BLOCK_CODES.CH], value: BMC_BLOCK_CODES.CH },
    { label: bmcBlocksObject[BMC_BLOCK_CODES.KP], value: BMC_BLOCK_CODES.KP },
    { label: bmcBlocksObject[BMC_BLOCK_CODES.KA], value: BMC_BLOCK_CODES.KA },
    { label: bmcBlocksObject[BMC_BLOCK_CODES.KR], value: BMC_BLOCK_CODES.KR },
    { label: bmcBlocksObject[BMC_BLOCK_CODES.CO], value: BMC_BLOCK_CODES.CO },
    { label: bmcBlocksObject[BMC_BLOCK_CODES.RE], value: BMC_BLOCK_CODES.RE },
    { label: bmcBlocksObject[BMC_BLOCK_CODES.SU], value: BMC_BLOCK_CODES.SU },
  ];
}

export {
  bmcBlocksObject,
  bmcBlockTestedOptions,
  bmcBlockShortNames,
  testStatusBlocks,
};
